export const emailPresence = value => {
  if (!value) return false
  return value.length > 0
}

export const validateEmail = value => {
  return value.match(
    // eslint-disable-next-line
    /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
  )
}

export const isEmailValid = value => {
  return emailPresence(value) && validateEmail(value)
}

const ruleMap = [
  {
    isValid: value => emailPresence(value),
    message: `Email is required`,
  },
  {
    isValid: value => validateEmail(value),
    message: `The email is not a valid format.`,
  },
]

export const emailValidation = value => {
  const errors = {}

  for (let index = 0; index < ruleMap.length; index++) {
    const rule = ruleMap[index]
    const validated = rule.isValid(value)
    if (!validated) {
      errors.email = rule.message
      return {
        isValid: false,
        errors,
      }
    }
  }

  return {
    isValid: true,
    errors,
  }
}
